import buildGraphQLProvider from "ra-data-graphql-amplication";
import { ApolloClient, ApolloLink, InMemoryCache, createHttpLink, from  } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { CREDENTIALS_LOCAL_STORAGE_ITEM } from "../constants";
import { removeTypenameFromVariables, KEEP } from '@apollo/client/link/remove-typename';
import {jwtAuthProvider} from '../auth-provider/ra-auth-jwt';
const removeTypenameLink = removeTypenameFromVariables()
  // {
  //   except: {
  //     JSON: KEEP
  //   }
  // }

function updateOptions(options: any) {
  const update = { ...options }; 
  if (localStorage.getItem(CREDENTIALS_LOCAL_STORAGE_ITEM)) {
    update.headers = {
      ...update.headers,
      Authorization: localStorage.getItem(CREDENTIALS_LOCAL_STORAGE_ITEM),
    };
  }
  if (options.body && typeof(options.body) === 'string') {
    update.body = options.body.replaceAll('__typename', '');
  }
  return update;
}
const checkError = (response:any)=>{
  const  json_data =async (response:any)=>{return JSON.parse(await response.text())} 
  json_data(response).then((response)=>{
   console.log(response);
   if (response.data && response.data?.err?.code === '401' ) {
     jwtAuthProvider.logout(true)
   }
   if (response.data && response.data?.err?.code === '403' ) {
     jwtAuthProvider.logout(true)
   }
  })
}
function fetcher(url: any, options: any):any {
 return fetch(url, updateOptions(options)).then((response)=>{
  let raw = response.clone()
  checkError(raw)
  return response
 })
}
const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_DATAPROVIDER}`,
  fetch: fetcher
});


// const authLink = setContext((_, { headers }) => {
//   const token = localStorage.getItem(CREDENTIALS_LOCAL_STORAGE_ITEM);
//   return {
//     headers: {
//       ...headers,
//       authorization: token ? token : "",
//     },
//   };
// });

// const asyncAuthLink = setContext(
//   request =>
//     new Promise((success, fail) => {
//       // do some async lookup here
//       setTimeout(() => {
//         success({headers: {
//           authorization: localStorage.getItem(CREDENTIALS_LOCAL_STORAGE_ITEM)
//         }});
//       }, 10);
//     })
// );

// const authLink = new ApolloLink((operation, forward) => {
//   // Retrieve the authorization token from local storage.
//   const token = localStorage.getItem(CREDENTIALS_LOCAL_STORAGE_ITEM);

//   // Use the setContext method to set the HTTP headers.
//   operation.setContext({
//     headers: {
//       authorization: token ? token : ''
//     }
//   });

//   // Call the next link in the middleware chain.
//   return forward(operation);
// });


const link = from([removeTypenameLink, httpLink]);
export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: link,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
    mutate: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
  }
});





export default buildGraphQLProvider({
  client: apolloClient,
});
